import React from 'react';
import Typing, { Cursor } from '../../Typewriter'
import { ScrollDown } from "../../ScrollDown";
import { SocialButton } from "../../SocialButton";
const HomeHero = () => (
    <section className="section-c section-1">
        <div className="title">
            <h1> Adrian Gabriel Manduc</h1>
            <Typing className="typewriter" cursor={<Cursor />} loop={true} speed={75} startDelay={1000}>
                <span>Fullstack Developer</span>
                <Typing.Backspace count={20} delay={200} />
                <span>Mobile App Developer</span>
                <Typing.Backspace count={20} delay={200} />
                <span>UI/UX Designer</span>
                <Typing.Backspace count={25} delay={200} />
                <span>Problem Solver</span>
                <Typing.Backspace count={14} delay={200} />
                <span>I deal with bugs - unless they move</span>
                <Typing.Backspace count={36} delay={200} />
            </Typing>
        </div>
        <div className="cv">
            <button onClick={() => window.open("https://drive.google.com/file/d/1WaA6915j-skXkM1368EiCMbYWCVCt3wA/view?usp=sharing", "_blank")} className="btn"> <i className="fa fa-download"></i> Download CV</button>
        </div>
        <ScrollDown></ScrollDown>
        <div className="geometry">
            <svg className=" hero-triangles" viewBox="0 0 263.07 394.61" preserveAspectRatio="xMinYMax meet">
                <polygon className="primary-triangle" points="0 394.61 0 0 263.07 263.07 131.53 394.61 0 394.61"></polygon>
                <polygon className="gray-triangle" points="0 394.61 0 263.07 131.53 394.61 0 394.61"></polygon>
                <polygon className="gray-triangle" points="131.53 394.61 197.3 328.84 263.07 394.61 131.53 394.61"></polygon>
            </svg>
            <div className=" upper-triangles">
                <div className="triangle triangle-1">
                </div>
                <div className="triangle triangle-2">
                </div>
            </div>
            <div className="social">
                <SocialButton to="mailto:dev.adrianmanduc@gmail.com?Subject=Hello%20Adrian" target="_self" className="fa fa-envelope"></SocialButton>
                <SocialButton to="https://www.facebook.com/adriangabriel.manduc" className="fa fa-facebook"></SocialButton>
                <SocialButton to="https://twitter.com/adrianmanduc" className="fa fa-twitter"></SocialButton>
                <SocialButton to="https://github.com/adrianmanduc" className="fa fa-github"></SocialButton>
            </div>
        </div>
    </section>
);

export default HomeHero;


// WEBPACK FOOTER //
// ./src/components/home/Hero/index.js